<template>
  <div>
    <base-crud
      crudName="Gerenciamento de Férias"
      newText="Novo Registro"
      :table="vacationsTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      vacationsTable: "vacationsTable",
      users: [],
      pages: [],
      url: "",
      columns: [
        "id",
        "user_id",
        "start_date",
        "end_date",
        "number_of_days",
        "pecuniary_allowance",
        "responsible_id",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "user_id",
        "start_date",
        "end_date",
        "number_of_days",
        "pecuniary_allowance",
        "responsible_id",
        "status",
        "actions",
      ],
      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "user_id",
          "start_date",
          "end_date",
          "number_of_days",
          "pecuniary_allowance",
          "responsible_id",
          "status",
        ],
        sortable: ["id", "title", "date"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Colaborador",
          start_date: "Data Início",
          end_date: "Data Fim",
          number_of_days: "Número de Dias",
          pecuniary_allowance: "Abono Pecuniário?",
          responsible_id: "Responsável",
          status: "Status",
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user", "responsible"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user.name;
          },
          responsible_id: function (h, row, index) {
            return row.responsible.name;
          },
          status: function (h, row, index) {
            return row.status == 1 ? "Aprovado" : "Não Aprovado";
          },
        },
      },
      endPoint: "vacations/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        title: "title",
        date: "date",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Vacations/Crud.vue